import { DialogContent, DialogTitle, Table, TableBody } from '@mui/material';

import RowIfNotEmpty from './Row';
import DialogWrapper from './Wrapper';
import { FVBill } from '../../../lib/interface';

const formatDate = (value: string): string => {
  const d = new Date(value);
  if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0 && d.getUTCMilliseconds() === 0) {
    return value.split('T')[0];
  }
  return value;
};

type Props = {
  open: boolean;
  handleClose: () => void;
  bill: FVBill;
};

export function BillDetails({ open, handleClose, bill }: Props): JSX.Element {
  return (
    <DialogWrapper
      id=""
      onClose={handleClose}
      aria-labelledby="bill-details-dialog-title"
      title="Bill Details"
      open={open}
    >
      <DialogContent dividers>
        <Table>
          <TableBody>
            {RowIfNotEmpty('Bill ID', bill.bill_id)}
            {RowIfNotEmpty('External Bill ID', bill.external_bill_id)}
            {RowIfNotEmpty('Status', bill.status)}
            {RowIfNotEmpty('Bill Date', formatDate(bill.bill_date))}
            {RowIfNotEmpty('Due Date', formatDate(bill.due_date))}
            {RowIfNotEmpty('Amount', bill.details.total_amount_due_raw)}
            {RowIfNotEmpty('Currency', bill.details.currency)}
            {RowIfNotEmpty('Description', bill.details.description)}
            {RowIfNotEmpty('Reference', bill.details.bill_reference_id)}
            {RowIfNotEmpty('Payer', bill.sender_details.name)}
            {RowIfNotEmpty('External User ID', bill.external_user_id)}
            {RowIfNotEmpty('Finverse User ID', bill.user_id)}
            {RowIfNotEmpty('Payment ID', bill.payment_id)}
            {RowIfNotEmpty('Autopay Eligible', bill.is_finverse_autopay_eligible ? 'Yes' : 'No')}
          </TableBody>
        </Table>
        <MetadataSection metadata={bill.metadata} />
        <IntegrationMetadataSection bill={bill} />
      </DialogContent>
    </DialogWrapper>
  );
}

function MetadataSection({ metadata }: { metadata?: Record<string, string> }) {
  if (!metadata || Object.keys(metadata).length === 0) return null;

  return (
    <>
      <DialogTitle sx={{ textAlign: 'center' }}>Metadata</DialogTitle>
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableBody>
          {Object.entries(metadata)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([key, value]) => RowIfNotEmpty(key, value, { key }))}
        </TableBody>
      </Table>
    </>
  );
}

function IntegrationMetadataSection({ bill }: { bill: FVBill }) {
  const { integration_metadata } = bill;

  const rapidstor = integration_metadata.rapidstor_metadata;
  const rapidstorRows = rapidstor
    ? Object.entries(rapidstor)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([key, value]) => RowIfNotEmpty(key, String(value), { key }))
    : [];

  return (
    <>
      <DialogTitle sx={{ textAlign: 'center' }}>Integration Metadata</DialogTitle>
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableBody>
          {RowIfNotEmpty('Integration ID', integration_metadata.integration_id)}
          {rapidstorRows}
        </TableBody>
      </Table>
    </>
  );
}
